type MemberAvatarProps = {
  name: string;
  src: string | null;
  size?: "sm" | "md";
};

/** Avatar de un miembro: foto real si la tiene, o su inicial. */
export default function MemberAvatar({ name, src, size = "md" }: MemberAvatarProps) {
  const dim = size === "sm" ? "w-8 h-8 text-xs" : "w-10 h-10 text-sm";
  if (src) {
    return <img src={src} alt={name} className={`${dim} rounded-full object-cover object-top flex-shrink-0`} />;
  }
  return (
    <span
      className={`${dim} rounded-full bg-primary-500/15 text-primary-700 flex items-center justify-center flex-shrink-0 font-heading font-bold`}
      aria-hidden="true"
    >
      {name.charAt(0).toUpperCase()}
    </span>
  );
}
